<template>
    <div id="form-inbox">
        <div class="header">
            <div class="pagination-controls">
                <button @click="prevPage" :disabled="answersData.currentPage === 1">Önceki</button>
                <span>Sayfa {{ answersData.currentPage }} / {{ answersData.totalPages }}</span>
                <button @click="nextPage" :disabled="answersData.currentPage >= answersData.totalPages">Sonraki</button>

                <select v-model="localPageSize" @change="changePageSize">
                    <option value="5">5 öğe/sayfa</option>
                    <option value="10">10 öğe/sayfa</option>
                    <option value="20">20 öğe/sayfa</option>
                    <option value="50">50 öğe/sayfa</option>
                    <option value="100">100 öğe/sayfa</option>
                </select>
            </div>
            <div class="header-item" @click="$router.push({ path: '/form', query: { type: 'list' } })">
                <md-icon class="icon">arrow_back</md-icon>
                <span class="header-text">Geri</span>
            </div>
            <div class="header-item" @click="filterStatusForm('notRead')">
                <md-icon class="icon">inbox</md-icon>
                <span class="header-text">Gelen Kutusu ({{ answersData.notRead }})</span>
            </div>
            <div class="header-item" @click="filterStatusForm('read')">
                <md-icon class="icon">send</md-icon>
                <span class="header-text">Okundu ({{ answersData.read }})</span>
            </div>
            <div class="header-item" @click="filterStatusForm('archive')">
                <md-icon class="icon">archive</md-icon>
                <span class="header-text">Arşiv ({{ answersData.archive }})</span>
            </div>
        </div>

        <div class="container">
            <div class="inbox-menu">
                <InboxMenu
                    v-if="!loading"
                    :answersData="answersData"
                    @item-selected="formAnswers"
                    @change-page="changePage"
                    @change-page-size="changePageSize"
                />
                <div v-else class="spinner">
                    <svg class="spinner-icon" width="50px" height="50px" viewBox="0 0 50 50">
                        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>

            <div class="inbox-content">
                <InboxContents
                    v-if="selectedAnswer"
                    :submission-id="selectedAnswer.submission._id"
                    :not-read-btn="notReadBtn"
                    @mark-as-read="updateData"
                />
                <div v-else>
                    Detayları görmek için bir öğe seçin.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InboxMenu from "./FormInbox/InboxMenu.vue";
import InboxContents from "./FormInbox/InboxContents.vue";

export default {
    name: "FormInbox",
    components: {
        InboxMenu,
        InboxContents,
    },
    data() {
        return {
            formId: this.$route.params.formId,
            answersData: {
                notRead: 0,
                read: 0,
                archive: 0,
                submissions: [],
                currentPage: 1,
                totalPages: 1,
            },
            selectedAnswer: null,
            loading: true,
            filterStatus: "notRead",
            notReadBtn: true,
            localPageSize: 10,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
    },
    mounted() {
        const query = this.$route.query;

        const status = query.status || this.filterStatus;
        const page = parseInt(query.page, 10) || this.answersData.currentPage;
        const perPage = parseInt(query.perPage, 10) || this.localPageSize;

        this.localPageSize = perPage;
        this.getInboxForm(status, page);
    },
    methods: {
        ...mapActions({
            getFormSubmissions: "forms/getFormSubmissions",
        }),
        async getInboxForm(status = "notRead", page = this.answersData.currentPage || 1) {
            try {
                this.loading = true;
                this.$router.push({
                    query: {
                        page: page,
                        perPage: this.localPageSize,
                        status: status,
                    },
                });
                const data = await this.getFormSubmissions({
                    siteId: this.site._id,
                    formId: this.formId,
                    status: status,
                    page: page,
                    perPage: this.localPageSize,
                });
                this.answersData = data;
            } catch (error) {
                console.error("Form yanıtları alınırken hata oluştu:", error);
            } finally {
                this.loading = false;
            }
        },
        filterStatusForm(status) {
            this.filterStatus = status;
            this.notReadBtn = status === "notRead";
            this.answersData.currentPage = 1;

            this.$router.push({
                query: {
                    page: 1,
                    perPage: this.localPageSize,
                    status: status,
                },
            });

            this.getInboxForm(status, 1);
        },
        async changePage(page) {
            this.answersData.currentPage = page;
            await this.getInboxForm(this.filterStatus, page);

            this.$router.push({
                query: {
                    page: page,
                    perPage: this.localPageSize,
                    status: this.filterStatus,
                },
            });
        },
        async changePageSize(event) {
            const newSize = parseInt(event.target.value, 10);
            this.localPageSize = newSize;
            this.answersData.currentPage = 1;
            await this.getInboxForm(this.filterStatus, 1);
            this.$router.push({
                query: {
                    page: 1,
                    perPage: newSize,
                    status: this.filterStatus,
                },
            });
        },
        prevPage() {
            if (this.answersData.currentPage > 1) {
                this.changePage(this.answersData.currentPage - 1);
            }
        },
        nextPage() {
            if (this.answersData.currentPage < this.answersData.totalPages) {
                this.changePage(this.answersData.currentPage + 1);
            }
        },
        formAnswers(submissionId) {
            const selectedSubmission = this.answersData.submissions.find(
                (answer) => answer.submission._id === submissionId,
            );
            this.selectedAnswer = selectedSubmission;
        },
        updateData() {
            this.getInboxForm(this.filterStatus, this.answersData.currentPage);
        },
    }
};
</script>

<style lang="scss" scoped>
.pagination-controls {
    display: flex;
    align-items: center;
    margin-right: auto;
}

button {
    padding: 5px 10px;
    background-color: #0288d1;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;

    &:disabled {
        cursor: not-allowed;
    }
}

select {
    padding: 5px;
    border: 1px solid #0288d1;
    border-radius: 5px;
}
#form-inbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #e0f7fa;

    .header {
        display: flex;
        width: 100%;
        background-color: #0288d1;
        padding: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        .header-item {
            display: flex;
            align-items: center;
            padding: 5px 10px;
            margin: 0 5px;
            background-color: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            cursor: pointer;

            .icon {
                margin-right: 5px;
                font-size: 1.2rem;
                color: #0288d1;
            }

            .header-text {
                font-size: 1rem;
                color: #0288d1;
                font-weight: bold;
            }
        }
    }

    .container {
        display: flex;
        width: 100%;
        height: 94%;
        margin: 0px;
        padding: 0px;

        .inbox-menu {
            width: 25%;
            padding: 10px;
            border-right: 2px solid #e5e5f5;
        }

        .inbox-content {
            width: 75%;
            background-color: #ffffff;
            padding: 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }

    .spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .spinner-icon {
        animation: rotate 2s linear infinite;
    }

    .path {
        stroke: #0288d1;
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 150;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 90, 150;
            stroke-dashoffset: -124;
        }
    }
}
</style>
